import React from 'react'
import { DropdownMenu } from '@paypalcorp/pp-react'
import { getLocalizedContent } from '../helper'

const Dropdown = (props) => {
  return (
    <React.Fragment>
      <DropdownMenu
        className={props.className}
        label={props.label}
        options={props.options.map((t) => ({
          primaryText: getLocalizedContent(t.labelKey),
          value: t.value,
        }))}
        selectedItemIndex={props.options.findIndex(
          (t) => t.value === props.value,
        )}
        onSelection={props.handleOnSelect}
        style={props.style}
        errorText={props?.errorText || ''}
        error={!!props?.errorText}
      />
    </React.Fragment>
  )
}

export default Dropdown
